<input
    #writeComponent
    class="writable-input"
    type="number"
    [value]="model[path]"
    (input)="onValueChange($event)"
    (focusout)="onBlur()"
    *ngIf="editing"
/>
<label #readComponent [class.readable-input]="!isReadOnly" (click)="onEdit()" *ngIf="!editing">{{
    model && model[path] ? model[path] : '...'
}}</label>
